import React from "react";
import { InputGroup, FormControl } from "react-bootstrap";
import "./inputForm.css";

const Profile = ({
  title="",
  placeholder,
  field,
  setNewValue,
  Row,
  required = false,
  as = "input",
  readDataM=null
}) => {
  return (
    <>
      <InputGroup className="mb-3 inputForm__container">
        {title!=""&&(<InputGroup.Text className="inputForm__title">{title}</InputGroup.Text>)}
        <FormControl
          placeholder={placeholder}
          aria-label="Username"
          aria-describedby="basic-addon1"
          onChange={(input) => setNewValue(field, input.target.value)}
          value={Row[field]}
          required={required}
          as={as}
        />
        {/* <FormControl.Feedback type="invalid">
          Please provide a {title}.
        </FormControl.Feedback> */}
      </InputGroup>
    </>
  );
};
export default Profile;
